import { connect, MapDispatchToProps } from 'react-redux';
import { attemptSocialLogin } from '../redux/actions';
import { Props } from './SocialButtonTest';

type DispatchProps = Pick<Props, 'attemptSocialLogin'>;
type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  attemptSocialLogin,
};

export default connect(null, mapDispatchToProps);
